import React, { Component } from 'react'
import { connect } from 'react-redux'

// Utils
// import { formatCurrency } from '../../../../utils/currency'
import { translation } from '../../../../utils/helpers'
import OtherPriceModal from '../../../../shared/modals/OtherPriceModal'
import Icon from '../../../elements/icon'
import { ElementIcons } from '../../../elements/icons'

// Actions
import { triggerPopup } from '../../../../actions/backdrop'

import Line from '../Line'

import './other.scss'

class Other extends Component {
  constructor (props) {
    super(props)
    this.state = {
      showEditPopup: false
    }

    this.editModalDisplayState = this.editModalDisplayState.bind(this)
  }

  componentDidMount () {
    this.props.onRef(this)
  }

  componentWillUnmount () {
    this.props.onRef(undefined)
  }

  getTitle () {
    let showEditLink = this.props.showEditLink && this.props.order.OrderType === 4
    // let title = null
    // let icon = null
    // switch (this.props.order.OrderType) {
    //   case 1:
    //     title = translation(13360)
    //     icon = '/images/svgs/ordrer/Insurance-black.svg'
    //     break
    //   case 2:
    //     title = translation(71)
    //     icon = '/images/svgs/ordrer/Salescar-black.svg'
    //     break
    //   case 3:
    //     title = translation(13361)
    //     icon = '/images/svgs/ordrer/Garanteed-black.svg'
    //     break
    //   case 4:
    //     title = translation(73)
    //     icon = '/images/svgs/ordrer/Other-black.svg'
    //     break
    //   case 6:
    //     title = translation(785)
    //     icon = '/images/svgs/ordrer/Private_c-black.svg'
    //     break
    // }

    return () => {
      return showEditLink && <Icon icon={ElementIcons.Edit} size='t' ariaText={translation('2706')} ariaPos='top' onClick={this.editModalDisplayState} />
      // return (
      //   <div >
      //     <div>
      //       <img src={icon} className='subtitleIMG' />
      //     </div>
      //     {title}
      //     {showEditLink && <div className='icon hint--top' aria-label={translation('2706')}><img src='/images/icons/edit_16.png' /></div>}
      //   </div>
      // )
    }
  }

  editModalDisplayState () {
    // console.log('this.state.showEditPopup', this.state.showEditPopup)
    this.props.triggerPopup(this.state.showEditPopup !== true)
    this.setState({
      showEditPopup: this.state.showEditPopup !== true
    })
  }

  render () {
    const beforeDiscountLabel = this.props.order.HasDiscount ? ` ${translation('15012')}` : ''

    // Paint
    const renderPriceAmount = () => {
      return (
        <Line text={translation('641') + beforeDiscountLabel} amount={this.props.order.Price || 0} />
      )
    }

    const renderEnvironmentAmount = () => {
      return (
        <Line text={translation('13339') + beforeDiscountLabel} amount={this.props.order.Environment || 0} />
      )
    }

    // Body
    const renderSparePartAmount = () => {
      return (
        <Line text={translation('637') + beforeDiscountLabel} amount={this.props.order.ManualBodySparePartPrice || 0} />
      )
    }

    const renderMiscAmount = () => {
      return (
        <Line text={translation('15154') + beforeDiscountLabel} amount={this.props.order.ManualBodyMiscPrice || 0} />
      )
    }

    const renderWorkPriceAmount = () => {
      return (
        <Line text={translation('416') + beforeDiscountLabel} amount={this.props.order.ManualBodyWorkPrice || 0} />
      )
    }

    const renderWorkEnvPriceAmount = () => {
      return (
        <Line text={translation('15156') + beforeDiscountLabel} amount={this.props.order.ManualBodyWorkEnvPrice || 0} />
      )
    }

    const renderTitle = () => {
      return (
        <div className='clearfix'>
          <label>{translation('1206')}</label>
          <span>{this.props.order.OtherTitle || ''}</span>
        </div>
      )
    }

    const renderDescription = () => {
      return (
        <div className='clearfix'>
          <label>{translation('1021')}</label>
          <span>{this.props.order.OtherDescription || ''}</span>
        </div>
      )
    }

    let showEditLink = this.props.showEditLink && this.props.order.OrderType === 4
    return (
      <div className='extent_other'>
        <div className='lines' onClick={showEditLink ? this.editModalDisplayState : undefined}>
          {this.props.order.OrderType === 4 && renderTitle()}
          {this.props.order.OrderType === 4 && renderDescription()}
          {this.props.order.OrderType === 4 && <div className='spacing triple' />}

          {this.props.department === 0 && renderPriceAmount()}
          {this.props.department === 0 && renderEnvironmentAmount()}

          {this.props.department === 1 && renderWorkPriceAmount()}
          {this.props.department === 1 && renderSparePartAmount()}
          {this.props.department === 1 && renderMiscAmount()}
          {this.props.department === 1 && renderWorkEnvPriceAmount()}

        </div>
        <OtherPriceModal
          type={1}
          show={this.state.showEditPopup}
          onClose={this.editModalDisplayState}
          other={{
            Title: this.props.order.OtherTitle,
            Description: this.props.order.OtherDescription,
            Price: this.props.order.Price,
            Environment: this.props.order.Environment
          }}
          bodyShopPrice={{
            ManualBodySparePartPrice: this.props.order.ManualBodySparePartPrice,
            ManualBodyMiscPrice: this.props.order.ManualBodyMiscPrice,
            ManualBodyWorkPrice: this.props.order.ManualBodyWorkPrice,
            ManualBodyWorkEnvPrice: this.props.order.ManualBodyWorkEnvPrice
          }}
          order={this.props.order}
          saveOrder={this.props.saveOrder}
          department={this.props.department} />
      </div>
    )
  }
}

Other.propTypes = {
  order: React.PropTypes.object.isRequired,
  editable: React.PropTypes.bool.isRequired
}

export default connect(null, { triggerPopup })(Other)



// WEBPACK FOOTER //
// ./src/app/shared/components/Extent/Other/index.js